import updateHomepageSettingsFooter from '../../../actions/siteadmin/updateHomepageSettingsFooter'
import { demoRestriction } from '../../../actions/demoRestriction';

async function submit(values, dispatch) {
    const isRestrict = await dispatch(demoRestriction({}));
    if (isRestrict) return;
    await dispatch(updateHomepageSettingsFooter(values))
}

export default submit;